import { render, staticRenderFns } from "./guide-order.vue?vue&type=template&id=67ba67e5&scoped=true&"
import script from "./guide-order.vue?vue&type=script&lang=js&"
export * from "./guide-order.vue?vue&type=script&lang=js&"
import style0 from "./guide-order.vue?vue&type=style&index=0&id=67ba67e5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba67e5",
  null
  
)

export default component.exports